import { useTranslator } from "@eo-locale/react";

import sortBy from "lodash/sortBy";
import { array } from "yup";

import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";
import { CommonCheckboxQuestion } from "@/storybook-components";
import { setAnswer } from "@/redux/features/place-form/slice";

export const validate = async (
  answer: string[],
  question: any
): Promise<string[]> => {
  let schema = array();
  if (question.required) {
    schema = schema.min(1).required();
  }
  if (question.checkboxAnswersLimit) {
    schema = schema.max(question.checkboxAnswersLimit);
  }
  try {
    await schema.validate(answer);
    return [];
  } catch (err) {
    return err.errors;
  }
};

const CheckboxQuestionComponent = ({ question }) => {
  const dispatch = useAppDispatch();
  const { translate } = useTranslator();

  const { answers, answerErrors } = useAppSelector((state) => state.placesForm);

  const answer = answers[question?.id] || [];

  const error = answerErrors[question?.id] || "";
  const { notes, required, id, questionOptions, question: title } = question;

  const handleChange = (value: any): void => {
    dispatch(
      setAnswer({
        questionId: question?.id,
        answer: value.length ? value.map(Number) : []
      })
    );
  };

  return (
    <CommonCheckboxQuestion
      answer={answer.map(String)}
      id={id}
      errorMessage={error && translate(`errors.${error}`)}
      handleChange={handleChange}
      isRequired={required}
      answerStackSpacing={2}
      note={notes}
      options={sortBy(questionOptions, (o) => o.sequence)}
      isHorizontal={false}
      isInvalid={error.length}
      spacing={0}
      withErrorIcon={true}
      questionLabel={title}
      answerProps={{
        minHeight: "0.75rem",
        className: "places-checkbox"
      }}
      questionLabelProps={{
        marginTop: 6
      }}
    />
  );
};

export default CheckboxQuestionComponent;
